import { render } from "./DashboardInsightsComponent.vue?vue&type=template&id=2b3dd9e2&scoped=true"
import script from "./DashboardInsightsComponent.vue?vue&type=script&lang=js"
export * from "./DashboardInsightsComponent.vue?vue&type=script&lang=js"

import "./DashboardInsightsComponent.vue?vue&type=style&index=0&id=2b3dd9e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3dd9e2"]])

export default __exports__